<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: [],
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div class="f-mini-tabs">
    <slot></slot>
    <div class="right" v-if="$slots.right">
      <slot name="right">test</slot>
    </div>
  </div>
</template>

<style lang="scss">
.f-mini-tabs {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgba(239, 239, 238, 1);

  > .right  {
    display: flex;
    flex: 1 1 100%;
    justify-content: flex-end;

    align-items: center;
  }
}

.f-mini-tabs>* {
  flex: 0 1 auto;
}

.dark-mode {
  .f-mini-tabs {
    border-bottom: 1px solid transparent;
  }
}
</style>